import { supabase } from './authService'
import { VideoItem } from '../types'

export interface DBShort {
  id: string
  title: string
  video_id: string
  channel_title: string
  channel_image: string | null
  channel_url: string | null
  description: string | null
  user_id: string | null
  is_hidden: boolean
  created_at: string
}

/**
 * Supabase에서 쇼츠 데이터를 가져옵니다.
 * 최신순으로 최대 100개까지 가져옵니다.
 */
export const fetchShortsFromSupabase = async (query?: string): Promise<VideoItem[]> => {
  try {
    let supabaseQuery = supabase
      .from('youtube_videos')
      .select('*')
      .order('created_at', { ascending: false })
      .limit(100);

    if (query) {
    supabaseQuery = supabaseQuery.or(`title.ilike.%${query}%,channel_name.ilike.%${query}%`);
  }

  const { data, error } = await supabaseQuery;

    if (error) throw error;

    return (data as any[]).map((item) => ({
      id: item.id,
      title: item.title,
      channel: item.channel_title || item.channel_name,
      videoId: item.video_id || item.id, // video_id가 없으면 id를 사용
      description: item.description || '',
      channelImage: item.channel_image || undefined,
      channel_url: item.channel_url || undefined,
      is_hidden: item.is_hidden || false,
    }));
  } catch (e) {
    console.error('Supabase Shorts Fetch Error:', e);
    return [];
  }
};

/**
 * 쇼츠 영상을 생성합니다.
 */
export const createShort = async (shortData: Partial<DBShort>) => {
  const { data: { user } } = await supabase.auth.getUser();
  const insertData = {
    ...shortData,
    user_id: user?.id || null
  };

  const { data, error } = await supabase
    .from('youtube_videos')
    .insert([insertData])
    .select();
  if (error) throw error;
  return data[0];
};

/**
 * 쇼츠 영상을 수정합니다.
 */
export const updateShort = async (id: string, shortData: Partial<DBShort>) => {
  const { data, error } = await supabase
    .from('youtube_videos')
    .update(shortData)
    .eq('id', id)
    .select();
  if (error) throw error;
  return data[0];
};

/**
 * 쇼츠 영상을 삭제합니다.
 */
export const deleteShort = async (id: string) => {
  const { error } = await supabase
    .from('youtube_videos')
    .delete()
    .eq('id', id);
  if (error) throw error;
};
